import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { StyledContentBlock, StyledTitle, StyledChildren, StyledAdditionalSwitcher } from './StyledComponents'

import { ExpandableContext } from './ExpandableBlocksContainer'
import { OpenTabContext } from 'components/SectionHandler/components/ItemView'
import uniqueId from 'lodash/uniqueId'

const ContentBlock = ({ children, style, className, label, alwaysExpanded, startExpanded, additionalSwitcher, blockId, showHeader, unmountOnCollapse, onHeaderClick, ...props }) => {
	const { expandedId, setExpandedId, nested } = useContext(ExpandableContext)
	let context = useContext(OpenTabContext)
	let openTabState, handleOpenTab
	if(context) {
		openTabState = context?.openTabState
		handleOpenTab = context?.handleOpenTab
	}

	const [id, setId] = useState(() => blockId || uniqueId())

	const isExpanded = alwaysExpanded || (startExpanded && typeof expandedId === 'undefined') || (expandedId === id || !setExpandedId)
	const canExpand = !alwaysExpanded && setExpandedId
	const isHeaderVisible = (label || (setExpandedId && !alwaysExpanded)) && showHeader
	const viewProps = { isExpanded, canExpand }

	useEffect(() => {
		if(openTabState?.label === label && label) {
			setId(openTabState.id)
			setExpandedId(openTabState.id)
		}
	}, [openTabState?.recordId])

	const handleClick = (event) => {
		event.preventDefault()
		if(!nested && canExpand && context) {
			handleOpenTab(!isExpanded, id, label)
		}
		if(canExpand) {
			setExpandedId(isExpanded ? null : id)
		}
		!!onHeaderClick && onHeaderClick(event, !isExpanded) //isExpanded can't update it's value in time, and due to this, we are return it with '!' - by this, we can get the relevant value of it.
	}

	return(
		<StyledContentBlock
			{...props}
			{...viewProps}
			style={style}
			className={cn(className, { 'theme-light': nested })}
			nested={nested}
		>
			{isHeaderVisible &&
				<StyledTitle {...props} {...viewProps} onClick={handleClick}>{label}</StyledTitle>
			}
			{unmountOnCollapse
				? isExpanded &&
				<StyledChildren withHeader={!!label}>
					{children}
				</StyledChildren>
				:
				<StyledChildren withHeader={!!label} isVisible={isExpanded}>
					{children}
				</StyledChildren>
			}
			{additionalSwitcher && isExpanded &&
				<StyledAdditionalSwitcher onClick={e => setExpandedId(null)}/>
			}
		</StyledContentBlock>
	)
}

ContentBlock.defaultProps = {
	showHeader: true,
	unmountOnCollapse: false
}

ContentBlock.propTypes = {
	blockId: PropTypes.string,
	showHeader: PropTypes.bool,
	alwaysExpanded: PropTypes.bool,
	startExpanded: PropTypes.bool,
	onHeaderClick: PropTypes.func,
	label: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	]), // Text with Divider displayed in top of the component
	related: PropTypes.bool, // Is component is connected to previous ContentBlock
	topBorder: PropTypes.bool, // Force set top border (By default top border applies or not from CSS)
	additionalSwitcher: PropTypes.bool, // Add button to collapse,
	unmountOnCollapse: PropTypes.bool
}

export default ContentBlock
